import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";

const ACTIONS = {
  requisition: {
    draft: ["submit", "cancel"],
    submitted: ["approve", "reject", "cancel"],
    approved: ["cancel"],
  },
  purchase_order: {
    draft: ["submit", "approve", "cancel"],
    pending_approval: ["approve", "reject", "cancel"],
    approved: ["send", "cancel"],
    sent: ["cancel"],
    confirmed: ["cancel"],
    partially_received: ["close", "cancel"],
    received: ["close"],
  },
};
const PRIMARY = ["submit", "approve", "send"];
const DANGER = ["reject", "cancel"];

// أزرار الأفعال المسموحة بحسب نوع المستند وحالته (متطابقة مع آلة الحالات في الخادم).
export const PurchaseActions = ({ doc, onRun, busy }) => {
  const { t } = useTranslation();
  const actions = (ACTIONS[doc.doc_type] || {})[doc.state] || [];
  if (!actions.length) return null;

  return (
    <div className="flex flex-wrap gap-2" data-testid="purchase-actions">
      {actions.map((action) => (
        <NeuButton
          key={action}
          variant={PRIMARY.includes(action) ? "primary"
                  : DANGER.includes(action) ? "danger" : undefined}
          className="px-3 py-2 text-xs"
          data-testid={`purchase-action-${action}`}
          data-po-action={`${action}-${doc.id}`}
          title={t(`purchases.actionHints.${action}`, "")}
          disabled={busy}
          onClick={() => onRun(action)}
        >
          {t(`purchases.actions.${action}`)}
        </NeuButton>
      ))}
    </div>
  );
};
